"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StorageUsageIconRow = void 0;
const components_1 = require("@veeam/components");
const react_1 = __importDefault(require("react"));
const helpers_1 = require("../../../../../helpers");
const components_2 = require("../../../components");
const helpers_2 = require("../../helpers");
const StorageWidgetCell_1 = require("../StorageWidgetCell");
const StorageUsageIconRow = ({ data }) => {
    const { length } = data;
    if (!length) {
        return null;
    }
    // 1 - 1; 2 - 2; 3 - 3; 4 - 2, 5 - 3, 6 - 3
    const itemsInRow = length <= 3 ? length : Math.ceil(length / 2);
    const width = `${Math.floor(100 / itemsInRow)}%`;
    const itemHeight = helpers_2.getRowHeight(data);
    const rowsNum = Math.ceil(length / itemsInRow);
    return (react_1.default.createElement(components_2.IRow, { height: rowsNum * itemHeight }, data.map((d, i) => {
        const index = i + 1;
        const borderRight = index < data.length && !!(index % itemsInRow);
        const numInRow = (i % itemsInRow) + 1;
        const paddingLeft = numInRow !== 1 ? components_1.SPACING_L : components_1.SPACING_M;
        return (react_1.default.createElement(components_2.IDiv, { key: helpers_1.hashCode(`${d.title}${d.description}`), width: width, borderRight: borderRight, paddingLeft: paddingLeft, height: itemHeight, paddingTop: "0" },
            react_1.default.createElement(StorageWidgetCell_1.StorageWidgetCell, { icon: d.icon, title: d.title, description: d.description, secondTitle: d.secondTitle, secondDescription: d.secondDescription })));
    })));
};
exports.StorageUsageIconRow = StorageUsageIconRow;
//# sourceMappingURL=StorageUsageIconRow.js.map